<template>
	<div class='knd-loader-container'>
		<div class='knd-loader' v-if="$store.state.loading">
			Laden
		</div>
	</div>

	<div class='knd-story' v-if="!$store.state.loading" >
		<Story />
	</div>
</template>

<script>
import Story from './components/story';


export default {
	name: 'App',
	mounted: function() {
		this.$store.dispatch('loadData');
		this.$store.dispatch('updateUserLoc', [4.477631590333832, 51.88882982765965]);
	},
	components: {
		Story,
	}
}
</script>